// Las preferencias, en un sitio y con quien las use apuntado.
//
// POR QUÉ EXISTE, Y ES UN CASO DEL 6 DE SEPTIEMBRE DE 2026. Gabri puso «Movimiento: con
// animaciones» en Ajustes, teniendo el Mac con «Reducir movimiento» encendido, y la celebración
// de recompensa siguió saliendo congelada. El ajuste estaba bien escrito, la regla de quién
// manda estaba bien escrita, y aun así no llegaba.
//
// LO QUE PASABA: `usePreferencias` guardaba las preferencias en un `useState` SUYO, y cada
// componente que lo llamaba se hacía su propia copia leyendo `localStorage` al montar. Hay
// nueve. La pantalla de Ajustes cambiaba la suya y la escribía en el almacén; las otras ocho
// seguían con la que leyeron al arrancar la aplicación, y como esto es una sola página que no
// se recarga al navegar, se quedaban con ella para siempre. **El ajuste se guardaba bien y no
// se enteraba nadie**, que es la avería de la casa de siempre: no da error, da silencio.
//
// Y SE VEÍA A MEDIAS, que es lo que lo hace difícil de coger: el efecto que cuelga los `data-`
// del `<html>` sí es global, así que todo lo que se apaga por CSS obedecía al instante. Sólo se
// quedaba atrás lo que pregunta en JavaScript —`useQuieto`, el reloj de los paneles, el cuarto
// del mentor, el lector de voz—. Media pantalla haciendo caso y media no.
//
// LA REGLA: **una preferencia es una sola, y quien la use se entera cuando cambia.** Aquí está
// el único ejemplar y la lista de quién quiere saberlo. Vive sin React —recibe el almacén y la
// ventana— para poder comprobar en Node lo único que de verdad importa: que si uno la cambia,
// los demás la ven.

import { CLAVE, guarda, lee } from "./preferencias.mjs";
import { LLAVE_VIEJA, loQueHereda } from "./canalesDeSonido.mjs";

/**
 * Monta el almacén. `almacen` es un `localStorage`; `ventana` sólo se usa para enterarse de los
 * cambios hechos en OTRA pestaña, y puede faltar.
 */
export function creaAlmacen(almacen, ventana) {
  let actuales = null;
  const oyentes = new Set();
  const avisa = () => oyentes.forEach((f) => f());

  // LA HERENCIA DEL BOTÓN VIEJO DE SILENCIO, que antes escribía su propia llave. Se hace una
  // vez, en la primera lectura, para que quien tenía la casa callada la siga teniendo callada.
  const primera = () => {
    const guardadas = lee(almacen);
    let viejo = null;
    try { viejo = almacen.getItem(LLAVE_VIEJA); } catch { /* sin almacén */ }
    const heredado = loQueHereda(guardadas.sonido, viejo === "1");
    return heredado ? guarda(almacen, { ...guardadas, sonido: heredado }) : guardadas;
  };

  // SE LEE UNA VEZ Y SE DEVUELVE SIEMPRE EL MISMO OBJETO mientras no cambie nada. No es
  // ahorro: `useSyncExternalStore` compara por identidad, y un objeto nuevo en cada lectura
  // es un repintado infinito.
  const ahora = () => {
    if (actuales === null) actuales = primera();
    return actuales;
  };

  const cambia = (siguientes) => {
    actuales = guarda(almacen, siguientes);
    avisa();
    return actuales;
  };

  const suscribe = (avisame) => {
    oyentes.add(avisame);
    return () => oyentes.delete(avisame);
  };

  // OTRA PESTAÑA ES OTRO SITIO DONDE CAMBIARLAS. Quien tiene la Academia abierta dos veces
  // -en el aula pasa- cambiaría el contraste en una y la otra seguiría igual hasta recargar.
  const deOtraPestana = (e) => {
    if (e && e.key && e.key !== CLAVE) return;
    actuales = lee(almacen);
    avisa();
  };
  if (ventana && ventana.addEventListener) ventana.addEventListener("storage", deOtraPestana);

  return { ahora, cambia, suscribe, deOtraPestana };
}
